export default __webpack_public_path__ + "static/media/FoxSports.5f4e17fc.svg";